import { useEffect, useRef, useState } from "react";
import { vocabularize } from "src/Common/vocab";
import Checkbox from "react-custom-checkbox";
import * as Icon from "react-icons/fi";
import { FaCheck } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

import POService from "src/Services/API/po.service";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { toast } from "react-toastify";
import { formatMoney, getImageUrl, getRealFileName } from "src/Common/common";
import { handleError } from "src/Common/function";
import WhiteUploadButton from "src/Components/Common/whiteuploadbutton";
import Loader from "src/Components/Common/Loader";
import UserService from "src/Services/API/user.service";
import VendorService from "src/Services/API/vendor.service";
import WOService from "src/Services/API/wo.service";
import VendorDropDown from "../dropdown/vendordropdown";
import PaymentDropdown from "./PaymentDropdown";
import OptionDropdown from "./OptionDropdown";
import { shipViaItems } from "src/Common/contants";
import TechDropDown from "src/Components/filter/components/TechDropdown";
import ConfirmDialog from "src/Common/confirmdialog";

// Shared input styling so the new fields match the pickers already on the form.
const INPUT_CLASS =
  "w-full border-solid border-[1px] border-borderColor rounded-[5px] text-inputEmailTitle text-[11px] font-OpenSansRegular px-2 py-1";
const LABEL_CLASS = "text-[12px] font-OpenSansSemiBold text-titleColor mb-2";
// Qty/Rate are numeric but the spinner arrows crowd an already tight row.
const NO_SPINNER =
  "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none";

const EMPTY_ITEM = { itemNumber: "", description: "", qty: "", rate: "", base64: "", name: "", type: "" };
const EMPTY_SHIP_TO = { name: "", address: "", city: "", state: "", zip: "", shipVia: "" };

// A line's extended amount. Blank/invalid inputs contribute nothing.
const lineAmount = (item) => {
  const qty = parseFloat(item.qty);
  const rate = parseFloat(item.rate);
  if (isNaN(qty) || isNaN(rate)) return 0;
  return qty * rate;
};

// Ship-to is stored as flat columns on the PO, so the form's block is
// flattened on the way out. Removing the block sends nulls rather than
// omitting the keys — an edit that clears the address has to actually clear it.
const shipToFields = (shipTo) => ({
  shipToName: shipTo?.name || null,
  shipToAddress: shipTo?.address || null,
  shipToCity: shipTo?.city || null,
  shipToState: shipTo?.state || null,
  shipToZip: shipTo?.zip || null,
  shipVia: shipTo?.shipVia || null,
});

// The line items as the API takes them. A row is dropped only when it is
// entirely blank — one carrying a part number and a price but no prose is
// still an item. `id` is carried on an edit so the server updates that row
// instead of replacing it (which would drop any file attached to it).
const submittableItems = (items) =>
  items
    .filter((item) => [item.itemNumber, item.description, item.qty, item.rate].some((v) => String(v ?? "").trim()))
    .map(({ id, itemNumber, description, qty, rate, base64, name, type }) => ({
      id,
      itemNumber,
      description,
      qty,
      rate,
      base64,
      name,
      type,
    }));

function CreatePoModal({ shown, onCancelClicked, onSubmitClicked, wo, editingPO }) {
  const currentUser = UserService.getCurrentUser();
  const [vendorList, setVendorList] = useState([]);
  //
  const [woNumber, setWONumber] = useState(wo?.number ?? editingPO?.wo?.number ?? "");
  const [woNumberError, setWONumberError] = useState("");
  const [po, setPo] = useState(null);
  // const [poNumber, setPoNumber] = useState(null);
  const [vendor, setVendor] = useState("");
  const [paymentType, setPaymentType] = useState(-1);
  const [description, setDescription] = useState("");
  const [note, setNote] = useState("");
  const [items, setItems] = useState([]);
  const [itemIndex, setItemIndex] = useState(0);
  // "simple" = non-itemised (Description shown); "detailed" = itemised (Item List
  // shown). The two modes map 1:1 to the two PDF layouts.
  const [mode, setMode] = useState("simple");
  // Optional single-entry blocks. `null` means "not added yet" — the + ADD
  // control is shown; adding swaps in an editable block.
  const [quoteNumber, setQuoteNumber] = useState(null);
  const [shipTo, setShipTo] = useState(null);
  const itemInputFile = useRef(null);
  const receiptInputFile = useRef(null);

  const [techArray, setTechArray] = useState([]);
  const [issuedUser, setIssuedUser] = useState(null);
  const [receipts, setReceipts] = useState([]);
  const [isUploadingReceipt, setIsUploadingReceipt] = useState(false);
  const [isReceiptDragActive, setIsReceiptDragActive] = useState(false);
  const receiptDragCounter = useRef(0);

  const [cancelled, setCancelled] = useState(false);
  const [cancelConfirmation, setCancelConfirmation] = useState(false);
  const [pricingLossConfirmation, setPricingLossConfirmation] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  //uploading attachment

  useEffect(() => {
    if (shown) {
      setVendorList([]);
      VendorService.getAllForSelection("")
        .then((response) => {
          if (response.status == 200) {
            setTimeout(() => {
              setVendorList(response.data.map((obj) => obj.name));
            }, 1000);
          }
        })
        .catch((error) => {
          console.log("Fetching Vendor List Error: ", error);
        });

      setTechArray([]);
      // UserService.getUsersByRole("Technician", wo.branch)
      //   .then((response) => {
      //     console.log("Tech response: ", response.data);
      //     if (response.status == 200) {
      //       setTechArray(response.data);
      //     }
      //   })
      //   .catch((error) => {
      //     console.log("tech fetching error: ", error);
      //   });

      // Roles are dynamic (managed in IAM), so the picker lists all enabled
      // users instead of hardcoding role names.
      UserService.getUsersForAssign(null, wo?.branch?.id)
        .then((response) => {
          if (response.status == 200) {
            setTechArray(
              response.data.filter((user) => user.isEnabled === true).sort((a, b) => a.name.localeCompare(b.name)),
            );
          }
        })
        .catch((error) => handleError(error));
    }
  }, [shown, vendor]);

  useEffect(() => {
    setIsSubmitting(false);
    if (editingPO && shown) {
      console.log("Editing po: ", po);
      setPo(editingPO);
      // setPoNumber(editingPO.number);
      setDescription(editingPO.description);
      setNote(editingPO.note);
      setVendor(editingPO.vendor);
      setPaymentType(editingPO.paymentType);
      setIssuedUser(editingPO.issuedUser || null);
      setReceipts([]);

      // Rate is re-formatted to 2dp so the field reads the way it was left,
      // and qty/rate come back as numbers — the inputs want strings.
      const existingItems = (editingPO.poItems || []).map((item) => ({
        id: item.id,
        itemNumber: item.itemNumber ?? "",
        description: item.description ?? "",
        qty: item.qty != null ? String(item.qty) : "",
        rate: item.rate != null ? Number(item.rate).toFixed(2) : "",
        base64: "",
        name: "",
        type: "",
      }));
      setItems(existingItems);
      // Both kinds of PO carry items, so the rows can't say which this is —
      // the PO records its own mode, and anything else is simple (the tech
      // app has no toggle and sends none).
      setMode(editingPO.mode === "detailed" ? "detailed" : "simple");
      setQuoteNumber(editingPO.quoteNumber ?? null);
      // `null` means "no ship-to block" — anything stored, even a lone Ship
      // Via, reopens the block rather than silently dropping it on the next
      // save.
      const existingShipTo = {
        name: editingPO.shipToName ?? "",
        address: editingPO.shipToAddress ?? "",
        city: editingPO.shipToCity ?? "",
        state: editingPO.shipToState ?? "",
        zip: editingPO.shipToZip ?? "",
        shipVia: editingPO.shipVia ?? "",
      };
      setShipTo(Object.values(existingShipTo).some(Boolean) ? existingShipTo : null);
    } else {
      setItems([]);
      // setPoNumber("");
      setDescription("");
      setVendor("");
      setIssuedUser(null);
      setReceipts([]);
      setMode("simple");
      setQuoteNumber(null);
      setShipTo(null);
    }
  }, [shown]);

  // Saving a detailed PO as a simple one strips the pricing off its lines —
  // the descriptions survive, the item numbers, quantities and rates don't —
  // and the fields holding them are hidden by the time Submit is in reach.
  // Confirm first, counting the lines that actually lose something.
  const repricedItemCount = (editingPO?.poItems ?? []).filter(
    (item) => item.itemNumber || item.qty != null || item.rate != null,
  ).length;
  const willDiscardPricing = Boolean(editingPO) && mode === "simple" && repricedItemCount > 0;

  const submitClicked = async () => {
    if (isSubmitting) return;

    if (willDiscardPricing) {
      setPricingLossConfirmation(true);
      return;
    }

    await runSubmit();
  };

  const runSubmit = async () => {
    // The guard covers the whole submit path (including the WO number
    // validation request) and is released in finally so a failed submit can
    // be retried from the same modal.
    setIsSubmitting(true);
    try {
      await doSubmit();
    } finally {
      setIsSubmitting(false);
    }
  };

  const doSubmit = async () => {
    let data;
    if (editingPO) {
      if (!woNumber?.trim()) {
        setWONumberError(vocabularize("Invalid Work Order Number"));
        return;
      }

      let response;
      try {
        response = await WOService.getWorkOrderByNumber(woNumber.trim());
        if (!response.data || !response.data.id) {
          setWONumberError(vocabularize("Invalid Work Order Number"));
          return;
        }
        setWONumberError("");
      } catch (error) {
        handleError(error);
        return;
      }

      data = {
        id: po.id,
        data: {
          wo: response.data.id,
          // number: poNumber,
          vendor: vendor,
          description: description,
          note: note,
          paymentType: paymentType,
          issuedUser: issuedUser,
          mode: mode,
          quoteNumber: quoteNumber || null,
          ...shipToFields(shipTo),
          // Both modes carry items. The pricing goes up either way and the
          // server clears it on a simple PO, so one side owns that rule.
          items: submittableItems(items),
          // receipts: receipts.filter((obj) => obj.base64),
        },
        eventUser: currentUser,
      };
    } else {
      // Amount and total are left to the server, which computes them from
      // qty x rate so the stored figures and the printed ones cannot drift
      // apart — and which drops the pricing altogether on a simple PO.
      const filtered = submittableItems(items);

      data = {
        po: {
          wo: wo?.id,
          // number: poNumber,
          vendor: vendor,
          description: description,
          note: note,
          paymentType: paymentType,
          mode: mode,
          quoteNumber: quoteNumber || null,
          ...shipToFields(shipTo),
          requestedUser: UserService.getCurrentUser().id,
          issuedUser: issuedUser,
          issuedBy: UserService.getCurrentUser().id,
          issuedDate: new Date(),
          status: 2,
          receipts: receipts,
        },
        items: filtered,
        eventUser: currentUser,
      };
    }

    console.log("data: ", data);
    await onSubmitClicked(data);
  };

  const paymentTypeClicked = (index) => {
    setPaymentType(index);
  };

  const addItem = () => {
    setItems([...items, { ...EMPTY_ITEM }]);
  };

  const removeItem = (indexToRemove) => {
    setItems((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  // Patch one field on one line item.
  const updateItem = (index, field, value) => {
    setItems((prev) => prev.map((item, i) => (i === index ? { ...item, [field]: value } : item)));
  };

  const itemsTotal = items.reduce((sum, item) => sum + lineAmount(item), 0);

  const updateShipTo = (field, value) => {
    setShipTo((prev) => ({ ...(prev ?? EMPTY_SHIP_TO), [field]: value }));
  };

  const uploadClicked = (index) => {
    itemInputFile.current.click();
    setItemIndex(index);
  };

  const descriptionChanged = (e, index) => {
    const newText = e.target.value;
    let temp = [...items];
    temp[index].description = newText;
    setItems(temp);
  };

  const vendorSelected = (option) => {
    console.log("selected vendor: ", option);
    setVendor(option);
  };

  const uploadReceipt = () => {
    receiptInputFile.current.click();
  };

  const resetReceiptDragState = () => {
    receiptDragCounter.current = 0;
    setIsReceiptDragActive(false);
  };

  const handleReceiptFiles = (files) => {
    if (files.length === 0 || editingPO) {
      return;
    }

    setIsUploadingReceipt(true);
    const validFiles = files.filter((file) => file.size <= 5242880);
    const invalidFiles = files.filter((file) => file.size > 5242880);

    if (invalidFiles.length > 0) {
      toast("Each file size cannot exceed more than 5MB");
    }

    if (validFiles.length > 0) {
      setReceipts((prev) => [...prev, ...validFiles.map((file) => ({ name: file.name, type: file.type, file }))]);
    }

    setIsUploadingReceipt(false);
  };

  const receiptSelected = (e) => {
    const files = Array.from(e.target.files || []);
    handleReceiptFiles(files);
    e.target.value = "";
  };

  const handleReceiptDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (editingPO || isUploadingReceipt) return;

    receiptDragCounter.current += 1;
    setIsReceiptDragActive(true);
  };

  const handleReceiptDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (editingPO || isUploadingReceipt) return;

    setIsReceiptDragActive(true);
  };

  const handleReceiptDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (editingPO || isUploadingReceipt) return;

    receiptDragCounter.current = Math.max(receiptDragCounter.current - 1, 0);
    if (receiptDragCounter.current === 0) {
      setIsReceiptDragActive(false);
    }
  };

  const handleReceiptDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (editingPO || isUploadingReceipt) return;

    const files = Array.from(e.dataTransfer.files || []);
    resetReceiptDragState();
    handleReceiptFiles(files);
  };

  const removeReceipt = (indexToRemove) => {
    setReceipts((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  const fileSelected = (e) => {
    const file = e.target.files[0];
    if (file.size > 5242880) {
      toast("File size cannot exceed more than 5MB");
      return;
    }

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result.split(",")[1];
        let temp = [...items];
        temp[itemIndex].base64 = base64;
        temp[itemIndex].name = file.name;
        temp[itemIndex].type = file.type;
        setItems(temp);
      };
      reader.readAsDataURL(file);
    }
  };

  const techSelected = (index) => {
    setIssuedUser(techArray[index]);
  };

  return (
    shown && (
      <div className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-30">
        <ConfirmDialog
          title="Cancel Purchase Order"
          description="Are you sure you want to cancel this purchase order?"
          shown={cancelConfirmation}
          onConfirmClicked={() => onCancelClicked()}
          onCancelClicked={() => setCancelConfirmation(false)}
        />

        <ConfirmDialog
          title="Remove item pricing?"
          description={`Saving as a simple purchase order clears the item number, quantity and rate on ${repricedItemCount} line${
            repricedItemCount === 1 ? "" : "s"
          }, and the PO's total. The descriptions are kept. This can't be undone.`}
          shown={pricingLossConfirmation}
          onConfirmClicked={() => {
            setPricingLossConfirmation(false);
            runSubmit();
          }}
          onCancelClicked={() => setPricingLossConfirmation(false)}
        />

        <OutsideClickHandler
          onOutsideClick={() => !cancelConfirmation && !pricingLossConfirmation && !isSubmitting && onCancelClicked()}
        >
          <div className="w-[520px] max-h-[88vh] bg-white rounded-[6px] flex flex-col relative">
            {/* upload button */}
            <div className="absolute flex flex-col top-[20px] right-[18px]">
              <input
                onChange={(e) => fileSelected(e)}
                type="file"
                id="file"
                ref={itemInputFile}
                style={{ display: "none" }}
                multiple={false}
                accept="image/*,application/pdf"
              />
              <input
                onChange={receiptSelected}
                type="file"
                id="receiptfile"
                ref={receiptInputFile}
                style={{ display: "none" }}
                multiple={true}
                accept="image/*,application/pdf"
              />
            </div>
            <div className="px-[18px] pt-[18px]">
              <p className="text-[16px] text-center font-OpenSansSemiBold text-titleColor mb-2">
                {editingPO ? "EDIT A PURCHASE ORDER" : "CREATE A PURCHASE ORDER"}
              </p>

              {/* Simple = non-itemised (Description); Detailed = itemised (Item
                  List). Available when editing too — switching to simple on an
                  existing PO clears its line items. */}
              <div className="flex items-center gap-1 bg-[#F4F5F8] rounded-[6px] p-[3px] mt-3">
                {["simple", "detailed"].map((option) => (
                  <button
                    key={option}
                    type="button"
                    onClick={() => setMode(option)}
                    className={`flex-1 h-[28px] rounded-[5px] text-[12px] capitalize transition-colors ${
                      mode === option
                        ? "bg-white text-blueColor font-OpenSansSemiBold shadow-sm"
                        : "text-subTitleColor font-OpenSansRegular"
                    }`}
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>

            <div className="flex flex-col mt-4 px-[18px] flex-1 overflow-y-auto">
              <div className="w-full ">
                <p className={LABEL_CLASS}>{vocabularize("WO #:")}</p>
                <input
                  value={woNumber}
                  type="text"
                  onChange={(e) => {
                    setWONumber(e.target.value);
                    if (woNumberError) setWONumberError("");
                  }}
                  disabled={!editingPO}
                  className={`${INPUT_CLASS} disabled:bg-gray-100 disabled:cursor-not-allowed ${
                    woNumberError ? "border-red-500" : ""
                  }`}
                  placeholder={vocabularize("Enter WO #")}
                />
                {woNumberError && <p className="text-red-500 text-[10px] font-OpenSansMedium mt-1">{woNumberError}</p>}
              </div>
              <div className="z-20 mt-4">
                <p className={LABEL_CLASS}>Payment Type:</p>
                <PaymentDropdown itemClicked={paymentTypeClicked} defaultValue={paymentType} />
              </div>
              <div className="w-full mt-4">
                <p className={LABEL_CLASS}>Vendor:</p>
                <VendorDropDown options={vendorList} defaultOption={vendor} onSelect={vendorSelected} />
              </div>
              {/* Simple POs carry a free-text Description instead of line items. */}
              {mode === "simple" && (
                <div className="w-full mt-4">
                  <p className={LABEL_CLASS}>Description:</p>
                  <textarea
                    value={description}
                    type="text"
                    onChange={(e) => setDescription(e.target.value)}
                    multiple={true}
                    className={`${INPUT_CLASS} h-[70px]`}
                    placeholder="Enter Description"
                  />
                </div>
              )}

              <div className="flex gap-2 mt-4 items-center">
                <p className="text-[12px] font-OpenSansSemiBold text-titleColor">Issued For:</p>
                <div className="flex-auto">
                  <TechDropDown options={techArray} selectedTech={issuedUser} onSelect={techSelected} />
                </div>
              </div>

              <div className="w-full mt-4">
                <p className={LABEL_CLASS}>Note:</p>
                <textarea
                  value={note}
                  type="text"
                  onChange={(e) => setNote(e.target.value)}
                  multiple={true}
                  className={`${INPUT_CLASS} h-[70px]`}
                  placeholder="Enter note — for internal use. Will not appear on PDF."
                />
              </div>

              {!editingPO && (
                <div className="w-full mt-4">
                  <div className="flex items-center justify-between gap-3">
                    <p className="text-[12px] font-OpenSansSemiBold text-titleColor">Attachments:</p>
                    <WhiteUploadButton isLoading={isUploadingReceipt} clicked={uploadReceipt} />
                  </div>
                  <div
                    className={`mt-2 rounded-[6px] border border-dashed p-3 transition-colors ${isReceiptDragActive ? "border-blueColor bg-[#F4F8FF]" : "border-borderColor"}`}
                    onDragEnter={handleReceiptDragEnter}
                    onDragOver={handleReceiptDragOver}
                    onDragLeave={handleReceiptDragLeave}
                    onDrop={handleReceiptDrop}
                  >
                    {receipts.length > 0 ? (
                      <div className="max-h-[70px] overflow-y-auto flex flex-col gap-2">
                        {receipts.map((attachment, index) => (
                          <div key={`${attachment.name}-${index}`} className="flex items-start justify-between gap-3">
                            <span className="flex-1 font-OpenSansRegular font-[400] text-[11px] text-titleColor break-all">
                              {attachment.name}
                            </span>
                            <button
                              type="button"
                              onClick={() => removeReceipt(index)}
                              className="shrink-0 cursor-pointer"
                            >
                              <MdDelete color="#010D3D" size={16} />
                            </button>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="font-OpenSansRegular text-[11px] text-subTitleColor">No attachments added yet.</p>
                    )}
                    <p className="mt-2 font-OpenSansRegular text-[10px] text-subTitleColor">
                      Drag and drop files here, or click upload.
                    </p>
                  </div>
                </div>
              )}

              {/* Everything below the rule is optional detail on top of the
                  basic PO above. */}
              <div className="w-full mt-5 border-t border-borderColor" />
              <p className="mt-3 text-[11px] font-OpenSansRegular text-subTitleColor">
                Optional: add line items below to build a detailed, itemized purchase order with quantities and
                pricing.
              </p>

              {/* Quote Number — at most one. */}
              <div className="w-full mt-4">
                <div className="flex items-center justify-between">
                  <p className="text-[12px] font-OpenSansSemiBold text-titleColor">Quote Number:</p>
                  {quoteNumber === null && (
                    <button
                      type="button"
                      onClick={() => setQuoteNumber("")}
                      className="text-blueColor text-[11px] font-OpenSansSemiBold cursor-pointer"
                    >
                      + ADD
                    </button>
                  )}
                </div>
                {quoteNumber !== null && (
                  <div className="mt-2 flex items-center gap-2">
                    <input
                      value={quoteNumber}
                      onChange={(e) => setQuoteNumber(e.target.value)}
                      className={INPUT_CLASS}
                      placeholder="Enter quote number"
                    />
                    <button type="button" onClick={() => setQuoteNumber(null)} className="shrink-0 cursor-pointer">
                      <Icon.FiX size={16} color="#80869E" />
                    </button>
                  </div>
                )}
              </div>

              {/* Item List — both modes, unlimited rows. A simple PO lists
                  descriptions and nothing else, which is what the tech app
                  creates; only a detailed one prices them. */}
              <div className="w-full mt-4">
                <div className="flex items-center justify-between">
                  <p className="text-[12px] font-OpenSansSemiBold text-titleColor">Item List:</p>
                  <button
                    type="button"
                    onClick={addItem}
                    className="text-blueColor text-[11px] font-OpenSansSemiBold cursor-pointer"
                  >
                    + ADD
                  </button>
                </div>

                {items.map((item, index) => (
                  <div
                    key={index}
                    className="relative mt-2 rounded-[6px] border border-borderColor bg-backgroundColor p-3"
                  >
                    <button
                      type="button"
                      onClick={() => removeItem(index)}
                      className="absolute top-2 right-2 cursor-pointer"
                    >
                      <Icon.FiX size={15} color="#80869E" />
                    </button>

                    {mode === "detailed" && (
                      <>
                        <p className="text-[10px] font-OpenSansSemiBold text-subTitleColor mb-1">ITEM #:</p>
                        <input
                          value={item.itemNumber}
                          onChange={(e) => updateItem(index, "itemNumber", e.target.value.toUpperCase())}
                          className={INPUT_CLASS}
                          placeholder="Enter item number"
                        />
                      </>
                    )}

                    <p
                      className={`${
                        mode === "detailed" ? "mt-2 " : ""
                      }text-[10px] font-OpenSansSemiBold text-subTitleColor mb-1`}
                    >
                      DESCRIPTION
                    </p>
                    <textarea
                      value={item.description}
                      onChange={(e) => updateItem(index, "description", e.target.value)}
                      className={`${INPUT_CLASS} h-[50px]`}
                      placeholder="Enter item description"
                    />

                    {mode === "detailed" && (
                      <div className="mt-2 grid grid-cols-3 gap-2">
                        <div>
                          <p className="text-[10px] font-OpenSansSemiBold text-subTitleColor mb-1">QTY</p>
                          <input
                            type="number"
                            min="0"
                            value={item.qty}
                            onChange={(e) => updateItem(index, "qty", e.target.value)}
                            className={`${INPUT_CLASS} ${NO_SPINNER} h-[28px]`}
                            placeholder="0"
                          />
                        </div>
                        <div>
                          <p className="text-[10px] font-OpenSansSemiBold text-subTitleColor mb-1">RATE</p>
                          <div className="relative">
                            <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[11px] text-subTitleColor">
                              $
                            </span>
                            <input
                              type="number"
                              min="0"
                              step="0.01"
                              value={item.rate}
                              onChange={(e) => updateItem(index, "rate", e.target.value)}
                              onBlur={(e) => {
                                const parsed = parseFloat(e.target.value);
                                updateItem(index, "rate", isNaN(parsed) ? "" : parsed.toFixed(2));
                              }}
                              className={`${INPUT_CLASS} ${NO_SPINNER} h-[28px] pl-5`}
                              placeholder="0.00"
                            />
                          </div>
                        </div>
                        <div>
                          <p className="text-[10px] font-OpenSansSemiBold text-subTitleColor mb-1">AMOUNT</p>
                          <div className="relative">
                            <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[11px] text-subTitleColor">
                              $
                            </span>
                            <input
                              value={formatMoney(lineAmount(item))}
                              readOnly
                              tabIndex={-1}
                              className={`${INPUT_CLASS} h-[28px] pl-5 bg-gray-100 cursor-not-allowed`}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}

                {mode === "detailed" && items.length > 0 && (
                  <div className="mt-3 pt-2 border-t border-borderColor flex items-center justify-between">
                    <p className="text-[12px] font-OpenSansSemiBold text-titleColor">Total</p>
                    <p className="text-[13px] font-OpenSansSemiBold text-titleColor">
                      ${formatMoney(itemsTotal)}
                    </p>
                  </div>
                )}
              </div>

              {/* Ship To — at most one. */}
              <div className="w-full mt-4">
                <div className="flex items-center justify-between">
                  <p className="text-[12px] font-OpenSansSemiBold text-titleColor">Ship To:</p>
                  {shipTo === null && (
                    <button
                      type="button"
                      onClick={() => setShipTo({ ...EMPTY_SHIP_TO })}
                      className="text-blueColor text-[11px] font-OpenSansSemiBold cursor-pointer"
                    >
                      + ADD
                    </button>
                  )}
                </div>
                {shipTo !== null && (
                  <div className="relative mt-2 rounded-[6px] border border-borderColor bg-backgroundColor p-3">
                    <button
                      type="button"
                      onClick={() => setShipTo(null)}
                      className="absolute top-2 right-2 cursor-pointer"
                    >
                      <Icon.FiX size={15} color="#80869E" />
                    </button>

                    <p className="text-[10px] font-OpenSansSemiBold text-subTitleColor mb-1">NAME</p>
                    <input
                      value={shipTo.name}
                      onChange={(e) => updateShipTo("name", e.target.value)}
                      className={INPUT_CLASS}
                      placeholder="Person or business name"
                    />

                    <p className="mt-2 text-[10px] font-OpenSansSemiBold text-subTitleColor mb-1">ADDRESS</p>
                    <input
                      value={shipTo.address}
                      onChange={(e) => updateShipTo("address", e.target.value)}
                      className={INPUT_CLASS}
                      placeholder="Street address"
                    />

                    <div className="mt-2 grid grid-cols-[2fr_1fr_1fr] gap-2">
                      <div>
                        <p className="text-[10px] font-OpenSansSemiBold text-subTitleColor mb-1">CITY</p>
                        <input
                          value={shipTo.city}
                          onChange={(e) => updateShipTo("city", e.target.value)}
                          className={`${INPUT_CLASS} h-[28px]`}
                          placeholder="City"
                        />
                      </div>
                      <div>
                        <p className="text-[10px] font-OpenSansSemiBold text-subTitleColor mb-1">STATE</p>
                        <input
                          value={shipTo.state}
                          onChange={(e) => updateShipTo("state", e.target.value)}
                          className={`${INPUT_CLASS} h-[28px]`}
                          placeholder="ST"
                        />
                      </div>
                      <div>
                        <p className="text-[10px] font-OpenSansSemiBold text-subTitleColor mb-1">ZIP</p>
                        <input
                          value={shipTo.zip}
                          onChange={(e) => updateShipTo("zip", e.target.value)}
                          className={`${INPUT_CLASS} h-[28px]`}
                          placeholder="Zip"
                        />
                      </div>
                    </div>

                    <p className="mt-2 text-[10px] font-OpenSansSemiBold text-subTitleColor mb-1">SHIP VIA:</p>
                    <OptionDropdown
                      options={shipViaItems}
                      value={shipTo.shipVia}
                      onSelect={(option) => updateShipTo("shipVia", option)}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="w-full mt-4 px-[18px] pb-[18px]">
              <div className="flex items-center justify-between gap-4">
                <div
                  onClick={onCancelClicked}
                  className="w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
                >
                  CANCEL
                </div>
                <button
                  type="button"
                  onClick={submitClicked}
                  disabled={isSubmitting}
                  className={`w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center ${
                    isSubmitting
                      ? "bg-gray-300 text-white cursor-not-allowed"
                      : "bg-blueColor text-white cursor-pointer"
                  }`}
                >
                  {isSubmitting ? <Loader variant="inline" size={16} ariaLabel="submitting-purchase-order" /> : "SUBMIT"}
                </button>
              </div>
            </div>
          </div>
        </OutsideClickHandler>
      </div>
    )
  );
}

export default CreatePoModal;
